var map = {
	"./": [
		"5s55",
		1
	],
	"./404": [
		"1Uj6",
		1
	],
	"./404.js": [
		"1Uj6",
		1
	],
	"./about": [
		"puyG",
		1,
		3
	],
	"./about.js": [
		"puyG",
		1,
		3
	],
	"./index": [
		"5s55",
		1
	],
	"./index.js": [
		"5s55",
		1
	],
	"./writing": [
		"YE21",
		1,
		0
	],
	"./writing/": [
		"YE21",
		1,
		0
	],
	"./writing/demo": [
		"BdWf",
		1,
		2
	],
	"./writing/demo/": [
		"BdWf",
		1,
		2
	],
	"./writing/demo/index": [
		"BdWf",
		1,
		2
	],
	"./writing/demo/index.js": [
		"BdWf",
		1,
		2
	],
	"./writing/demo/jsCodeExample.txt": [
		"WizQ",
		0,
		6
	],
	"./writing/demo/listItem.txt": [
		"tvoG",
		0,
		5
	],
	"./writing/demo/pic.png": [
		"qAGQ",
		0,
		4
	],
	"./writing/how-this-site-was-made": [
		"NSeT",
		1,
		1
	],
	"./writing/how-this-site-was-made/": [
		"NSeT",
		1,
		1
	],
	"./writing/how-this-site-was-made/index": [
		"NSeT",
		1,
		1
	],
	"./writing/how-this-site-was-made/index.js": [
		"NSeT",
		1,
		1
	],
	"./writing/index": [
		"YE21",
		1,
		0
	],
	"./writing/index.js": [
		"YE21",
		1,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return ids[1] === 1 ? module : ids[1] ? Object.assign({/* fake namespace object */}, typeof module === "object" && module, { "default": module }) : (typeof module === "object" && module && module.__esModule ? module : Object.assign({/* fake namespace object */}, typeof module === "object" && module, { "default": module }));
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3sfn";
module.exports = webpackAsyncContext;